import { BrandRepository } from "../Repository/BrandRepository";



export interface DeleteColorUseCase {
    invoke: (id: string) => Promise<boolean>;
  }
  
  export class RemoveBrand implements DeleteColorUseCase {
    private brandRepo: BrandRepository;
    constructor(_BrandRepo: BrandRepository) {
      this.brandRepo = _BrandRepo;
    }
  
    async invoke(id: string){
       
        if(!id){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const deleted  = await this.brandRepo.removeColor(id);
        return deleted;
    }
  }